import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, search = '', device_type = null, status = null, currentSortColumn, currentSortOrder) {
        let response = await axios.get(this.urls.list, {
            params: {
                page,
                limit,
                search,
                device_type,
                status,
                currentSortColumn,
                currentSortOrder
            }
        }).then(response => {
            if(response.data.items !== undefined)
            {
                if(response.data.items.length > 0)
                {
                    return response.data;
                }
            }
            return false;
        });

        let result = {
            tbody: [],
            pages: response.pages,
        };

        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(device => {
                let telem = {
                    tbody: {}
                };
                telem.id = device.id;
                telem.tbody.device_key = device.device_key;
                telem.tbody.pharmacy_number = device.pharmacy_number;
                telem.tbody.item = device.item;
                telem.tbody.status = device.status_id;
                telem.tbody.status_title = device.status_title;
                telem.tbody.type = device.type;
                telem.tbody.client_name = device.client_name;
                telem.tbody.org_name = device.org_name;
                telem.tbody.address = device.address;
                telem.tbody.worktime = device.worktime;
                telem.tbody.brand_name = device.brand_name;
                telem.tbody.license_key = device.license_key;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
